import { render, staticRenderFns } from "./CvssCol.vue?vue&type=template&id=1ef6f8b2"
import script from "./CvssCol.vue?vue&type=script&lang=js"
export * from "./CvssCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports